import Router from 'next/router';
import { IgetValidChangeProductsRes } from './types';
import { getQueryString } from '@framework/router';

interface IRedirectOptions {
  push?: (url: string, as?: string, options?: { shallow?: boolean }) => void,
}

export const isRedirectToDefaultActive = (
  {
    pathname,
    validProducts,
    validRegions,
    productsChanged,
    regionsChanged,
  }: IgetValidChangeProductsRes,
  options?: IRedirectOptions,
): boolean => {
  let shouldRedirect = false;

  if (productsChanged || regionsChanged) {
    shouldRedirect = true;
  }

  if (shouldRedirect && options?.push) {
    const search = getQueryString({ products: validProducts, regions: validRegions });
    const targetUrl = `${ pathname }?${ search }`;

    if (targetUrl === Router.asPath) {
      return false;
    }

    options.push(targetUrl, undefined, { shallow: false });
  }

  return shouldRedirect;
};
